import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./RefundAllotment.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import Button from "../../Subcomponents/Button";
import { useSelector } from "react-redux";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";

import {
  refundFromAllAllotmentPayment,
  refundTokenPayment,
} from "../../Services/PaymentApi";
import { getAllotmentCancelledTransection } from "../../Services/Payments";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  tokenName: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
    marginTop: "1rem",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },
}));

export default function RefundAllotment({
  open,
  handleClose,
  returnRes,
  data,
  allotmentData,
  allotmentTransaction,
}) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [allotmentTransactionFound, setAllotmentTransactionFound] =
    useState(null);
  const [showCancelledInFarvisionMsg, setShowCancelledInFarvisionMsg] =
    useState(false);
  function closeModal() {
    handleClose();
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  useEffect(() => {
    if (allotmentData.status !== "Cancellation Not Done") {
      presentLoader();
      getAllotmentCancelledTransection(allotmentData.allotmentpaymentid)
        .then((resp) => {
          resp?.length > 0 &&
            resp[0]?.cancelledInFarvision &&
            setShowCancelledInFarvisionMsg(true);
          setAllotmentTransactionFound(true);
          dismissLoader();
        })
        .catch((err) => {
          dismissLoader();
        });
    } else {
      if (allotmentTransaction.length > 0) {
        presentLoader();
        setAllotmentTransactionFound(true);
        dismissLoader();
      } else {
        presentLoader();
        setAllotmentTransactionFound(false);
        dismissLoader();
      }
    }
  }, [allotmentTransaction]);

  function save() {
    let body = {
      allotmentPaymentId: allotmentData.allotmentpaymentid,
    };
    presentLoader();
    refundFromAllAllotmentPayment(body)
      .then((respRefundTokenPay) => {
        if (respRefundTokenPay?.data?.success[0]?.status === "success") {
          // !!All Updates are Handled by Siddarth's refundtokenpayment api
          dismissLoader();
          handleClose();
          returnRes(true);
          successTost("Allotment refund initiated successfully");
        } else {
          handleClose()
          dismissLoader();
          errorTost(respRefundTokenPay?.data?.failed[0]?.reason);
        }
      })
      .catch((errInRefundPay) => {
        handleClose()
        dismissLoader();
        errorTost(errInRefundPay.message);
      });
  }
  return (
    <Modal
      open={true}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Allotment Refund</div>
        </div>
        {showCancelledInFarvisionMsg ? (
          <div className={cssClasses.wrapperContent}>
            <div className={cssClasses.blockLabel}>
              {" "}
              {/* Unit {allotmentData?.unitno} in wing {allotmentData?.wingName} of */}
              Unit {allotmentData?.unitno} in wing {allotmentData?.displayName ? allotmentData?.displayName : allotmentData?.wingName} of
              project {allotmentData.projectname} is cancelled in Farvision.
              Initiate refund cannot be performed
            </div>
          </div>
        ) : (
          <div className={cssClasses.wrapperContent}>
            {allotmentTransactionFound && (
              <div className={cssClasses.blockLabel}>
                Do you want to Initiate Refund of Unit {allotmentData?.unitno}{" "}
                {/* in wing {allotmentData?.wingName} of project{" "} */}
                in wing {allotmentData?.displayName ? allotmentData?.displayName : allotmentData?.wingName} of project{" "}
                {allotmentData.projectname}?
              </div>
            )}
            {!allotmentTransactionFound && (
              <div className={cssClasses.blockLabel}>
                Refund of Unit {allotmentData?.unitno} in wing{" "}
                {/* {allotmentData?.wingName} of project {allotmentData.projectname}{" "} */}
                {allotmentData?.displayName ? allotmentData?.displayName : allotmentData?.wingName} of project {allotmentData.projectname}{" "}
                is already done!
              </div>
            )}
          </div>
        )}
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={() => {
                closeModal();
              }}
            />
          </div>
          {allotmentTransactionFound && (
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  opacity: allotmentTransaction?.length === 0 ? 1 : 0.7,
                }}
                btnName={"Initiate Refund"}
                clicked={() => {
                  save();
                }}
                disable={!allotmentTransactionFound}
              />
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
}
